import { Button } from '@bambi/component-library/src/components/Button/Button';
import { useFormContext } from 'react-hook-form';


export function FormCancelButton({
  className,
  isSubmitting,
  onCancel,
}: {
  className?: string;
  isSubmitting?: boolean;
  onCancel: () => void;
}) {
  const { formState, reset } = useFormContext();

  return (
    <Button
      className={className}
      onClick={() => {
        reset();
        onCancel();
      }}
      disabled={isSubmitting || formState.isSubmitting}
    >
      Cancel
    </Button>
  );
}
